import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";

const ProtectedRoute = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [securityEnabled, setSecurityEnabled] = useState(null);
  const queryParams = new URLSearchParams(location.search);
  
  const hasSecretKey = queryParams.get("access") === "granted";

  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setSecurityEnabled(data.securityEnabled === true))
      .catch(() => setSecurityEnabled(true));
  }, []);
  
  useEffect(() => {
    if (hasSecretKey) {
      // 1. Session set karein
      sessionStorage.setItem("allowSite", "true");
      
      // 2. URL se "?access=granted" ko hata dein taaki copy na ho sake
      navigate(location.pathname, { replace: true });
    }
  }, [hasSecretKey, navigate, location.pathname]);

  if (securityEnabled === null) return null;

  const isAllowed = !securityEnabled || sessionStorage.getItem("allowSite") === "true";

  if (!isAllowed) {
    return <Navigate to="/404" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;








// import React from "react";
// import { Navigate, Outlet } from "react-router-dom";

// const ProtectedRoute = ({ securityOn }) => {
//   const isAllowed = 
//     localStorage.getItem("allowSite") === "true" || 
//     sessionStorage.getItem("allowSite") === "true";

//   if (!securityOn || isAllowed) {
//     return <Outlet />;
//   }

//   return <Navigate to="/404" replace />;
// };

// export default ProtectedRoute;